import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonDirective } from './common.directive';


      
@NgModule({
  declarations: [
    CommonDirective
  ],
  imports: [
    CommonModule,
  ],exports:[
    CommonDirective
  ]
})
export class DirectiveModule {
    static forRoot(): ModuleWithProviders<DirectiveModule> {
        return {
            ngModule: DirectiveModule
        }
    }
}
